import {RoadModel} from "./models/RoadModel";
import {Road} from "./models/Road";
import { AsyncTask } from '@/js/task.js'
import { RoadDrawer } from '@/drawings3D/modelDrawing/RoadDrawer.js'
export class RoadManager {
  constructor(sceneManager, axios, web3DView) {
    this.sceneManager = sceneManager;
    this.axios = axios;
    this.web3DView = web3DView;
    this.roads = [];
  }

  assignRoadMaterials(materails){
    this.roadMaterials = materails;
    
  }
  drawRoadStakeByPos(lon, lat, afterModelLoaded, callbackArg, firstInit, roadPartOption){
    //如果是第一次渲染，则需要移动摄像头到道路起点后方
    //lat:25.400434066834475, lon:103.82851105262998
    var that = this;
    var getRoadUrl = 'getRoundRoad?lng=' + lon + '&lat=' + lat + '&distance=' + (this.sceneManager.activeCamera.get().far * 1.2);
    if (!firstInit){
      getRoadUrl = 'getRoundRoadByXY?x=' + lon + '&y=' + lat + '&distance=' + (this.sceneManager.activeCamera.get().far * 1.2);
    }
  
    if (roadPartOption != undefined) this.roadPartOption = roadPartOption;
    that.web3DView.taskManager = new AsyncTask("道路渲染中", function() {

      },  function(afterLoadArgs){
             if (afterModelLoaded) afterModelLoaded.call(callbackArg); 
      }, {
        scope: that.web3DView,
        arguments: {
          
        }
      });
      that.web3DView.taskManager.start();

      var renderTaskfunc = {
        scope: that,
        async:true,
        func: function(){
            that.axios.get(getRoadUrl).then(function(response) {
            var data = response.data;
            if(data == "") return;
            var roadName = data.roadName;
            var roadData = data.roadData;
            var roadId = data.roadId;
            var roadType = data.roadType;
            that.sceneManager.resetCameraPosStatus(true); 
            //第一次渲染需要确定坐标的offset以减轻计算负担
            if (that.sceneManager.CoordOffset == undefined){
              that.sceneManager.CoordOffset = { lat: roadData[0].gisData.latitude, lon: roadData[0].gisData.longtitude };  
            }
            
            that.sceneManager.actualStakeVal=roadData[0].actualStakeVal;
            
            if (!that.roads[roadId]){
              that.roads[roadId] = new Road(roadId, roadType, roadName, that.sceneManager);
            }
            var roadStakeRanges = that.roads[roadId].process(data);
            var renderTasks = [];
            roadStakeRanges.map(item=>{
              that.web3DView.taskManager.addTaskGroup("正在生成道路", "renderRoad", renderTasks);
              var roadDrawer = new RoadDrawer(item, that.sceneManager, that, firstInit, that.roadPartOption);
              // roadDrawer.render(that.web3DView);
              renderTasks.push({
                scope: roadDrawer,
                func : roadDrawer.render,
                param:that.web3DView
              })
 
            });
            that.web3DView.taskManager.notifyTaskComplete("getRoadData", 0);
            that.web3DView.taskManager.exec("renderRoad", 0);
            var earthData = response.data.demGrid;
            that.sceneManager.earthData = earthData;

            if (firstInit){
              //获取地图数据
              //将目标道路在地图上标注
              var getGisDataUrl = 'getRoadGisDataById?roadId=' + roadId;
              that.axios.get(getGisDataUrl).then(function(response){
                  var data = response.data;
                  that.sceneManager.webView.map.markRoad(data);  
              });  
            }
            
            
          }).catch(function(error) {
            that.sceneManager.resetCameraPosStatus(false); 
            console.log(error);
          });
          

          }
      };
     
    that.web3DView.taskManager.addTaskGroup("下载道路数据","getRoadData", [renderTaskfunc]);
    that.web3DView.taskManager.exec("getRoadData", 0);

    
  }
  
  addRenderedMesh(roadId, roadModel, range, renderedMesh){
    this.roads[roadId].addRenderPart(roadModel, range, renderedMesh);
    
  }

  getChildren() {
    var childArr = new Array();
    for (var prop in this) {
      if (this[prop] instanceof RoadDrawer) {
        this[prop].mesh.children.map(item => childArr.push(item))

      }
    }
    return childArr;
  }


  selectStation(station, roadName, ignoreCameraMove) {
    var road = this[roadName];
    if (road == undefined) {
      return;
    }
    if (road.model.roadunitMap[station] != undefined) {
      var roadUnit = road.model.roadunitMap[station];

      if (this.lastSelectObject != undefined && this.lastSelectObject.deselect != undefined) {
        this.lastSelectObject.deselect.call(this.lastSelectObject);
      }

      if (ignoreCameraMove == undefined || !ignoreCameraMove) {
        this.sceneManager.camera.moveToRoadUnit(roadUnit);
      }
      this.lastSelectObject = roadUnit.roadsurface;
      //更新纵断面图
      roadUnit.road.moveToVerticalTransectCenter(roadUnit.start);

      roadUnit.displayCriticalPoints(road.sceneManager);
    }
    return roadUnit;
  }

  selectNextStation(station, roadName) {
    var road = this[roadName];
    if (road == undefined) {
      return;
    }

    if (road.model.roadunitMap[station] != undefined) {
      var roadUnit = road.model.roadunitMap[station];
      return this.selectStation(roadUnit.nextStakevaL, roadName);
    }
  }

  selectPrevStation(station, roadName) {
    var road = this[roadName];
    if (road == undefined) {
      return;
    }

    if (road.model.roadunitMap[station] != undefined) {
      var roadUnit = road.model.roadunitMap[station];
      return this.selectStation(roadUnit.prevStakevaL, roadName);
    }
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/RoadManager.js